var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7309 4.11512L15.4909 7.63512C15.7309 8.12512 16.3709 8.59512 16.9109 8.68512L20.1009 9.21512C22.1409 9.55512 22.6209 11.0351 21.1509 12.4951L18.6709 14.9751C18.2509 15.3951 18.0209 16.2051 18.1509 16.7851L18.8609 19.8551C19.4209 22.2851 18.1309 23.2251 15.9809 21.9551L12.9909 20.1851C12.4509 19.8651 11.5609 19.8651 11.0109 20.1851L8.02089 21.9551C5.88089 23.2251 4.58089 22.2751 5.14089 19.8551L5.85089 16.7851C5.98089 16.2051 5.75089 15.3951 5.33089 14.9751L2.85089 12.4951C1.39089 11.0351 1.86089 9.55512 3.90089 9.21512L7.09089 8.68512C7.62089 8.59512 8.26089 8.12512 8.50089 7.63512L10.2609 4.11512C11.2209 2.20512 12.7809 2.20512 13.7309 4.11512Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.56c68368ae69caf9de4d83601a991c32.svg";
export { ForwardRef as ReactComponent };